import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'htmlListDisplay',
  standalone: false,
})
export class HtmlListDisplayPipe implements PipeTransform {
  transform(value: string[]): string {
    const listEntries =
      value
        ?.map((rawString, index) => `<li>${rawString.trim() + (index === value.length - 1 ? '' : ',')}</li>`)
        .join('') ?? '';

    return `<ul>${listEntries}</ul>`;
  }
}
